import {UploadDto} from '../../../models/dtos/upload.dto';
import {UploadRequest} from '../../../models/requests/upload.request';
import axios from '../../../utilities/axios';

export const uploadRequest = async (request: UploadRequest): Promise<UploadDto> => {
  try {
    const formData = new FormData();
    formData.append('file', request.file);
    const config = {
      headers: {
        'content-type': 'multipart/form-data'
      }
    }
    const response = await axios.post<UploadDto>(
      `${process.env.REACT_APP_BASE_URL_AUTO_LOGIN}/upload/image`,
      formData,
      config,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
